// Canonical Supabase client for the entire application.
//
// Use this from anywhere that needs to talk to Supabase. Centralising
// `createClient` to one module means we have ONE auth session, ONE place
// to add interceptors / retries / logging, and ONE place to change keys.
//
// History: this module used to live at `src/services/optimization/client.ts`
// because the optimization layer was first to need it. M-A pulled it to
// the top of `services/` since it's used by every domain service.

import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
);
